import { COOKIES_DOMAIN } from "../constants/cookies";

export const cookieValueByNameInlineScript = `
		const cookieValueByName = cookieName => {
			if (!cookieName) return null;
			var b = document.cookie.match('(^|;)\\\\s*' + cookieName + '\\\\s*=\\\\s*([^;]+)');
			return b ? b.pop() : null;
		}
`;

export const setCookieInlineScript = `
		const setCookie = (name, value, exdays) => {
				const d = new Date();
				d.setTime(d.getTime() + (exdays*24*60*60*1000));
				var expires = "expires="+ d.toUTCString();
				document.cookie = name + "=" + value + ";" + expires + ";domain=${COOKIES_DOMAIN};path=/";
		}
`;

export const shouldRecordFromDrawInlineScript = `
		const shouldRecordFromDraw = (recordEveryNth) => {
		if (!recordEveryNth) return false;
			return Math.ceil(Math.random() * recordEveryNth) === recordEveryNth;
		}
`;
